'use strict';

angular.module('uniromaLandingApp')
    .factory('RejectedType', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/rejectedTypes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);
